import { AddCircleOutline } from "@mui/icons-material";
import { Box } from "@mui/material";
import Input from "../../../../components/input/Input-v2";
import { ModalFC } from "../../../../components/modal/Modal";
import { useState } from "react";
import { LoadingButton } from "../../../../components/button/Button";
import useGenerateOptions from "../../../../components/input/hook/useGenerateOptions2";
import { useAddBrand, useGetBrands } from "../../api/product/brand/resolver";

interface InputBrand {
  control: any;
  controlName: string;
  disabled?: boolean;
}

export default function InputBrand({
  control,
  controlName,
  disabled,
}: InputBrand) {
  const [keyword, setKeyword] = useState<string>();
  const { mutate, isLoading } = useAddBrand();
  const { data: dataRaw, isLoading: isFetching } = useGetBrands({
    keyword,
    page: 1,
  });
  const dataBrand = dataRaw?.data.data.data;
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const { data: dataOptionBrand } = useGenerateOptions({
    keyForText: "brand_name",
    keyForValue: "id",
    dataSource: dataBrand,
  });

  const handleAdd = () => {
    mutate({
      brand_name: name,
    });
  };

  return (
    <Box display={"flex"} gap={1} height={"100%"}>
      <Box flexBasis={"90%"}>
        <Input.Controller
          control={control}
          name={controlName}
          rules={{ required: "Kolom ini tidak boleh kosong" }}
          render={(field, fieldState) => (
            <Input.Autocomplete
              disable={disabled}
              isFetching={isFetching}
              label="Brand"
              options={dataOptionBrand}
              onChange={(e) => setKeyword(e)}
              onClick={(e) => field.onChange(e.value)}
              value={field.value}
              error={fieldState.error?.message}
            />
          )}
        />
      </Box>
      {!disabled && (
        <Box
          display={"flex"}
          height={"100%"}
          alignItems={"flex-end"}
          onClick={() => setShowModal(true)}
        >
          <AddCircleOutline
            style={{ cursor: "pointer" }}
            color={"primary"}
            fontSize={"large"}
          />
        </Box>
      )}
      <ModalFC open={showModal} onClose={() => setShowModal(false)}>
        <Input.Text
          label="Nama Brand"
          value={name}
          onChange={(e) => setName(e)}
        />
        <Box display={"flex"} justifyContent={"flex-end"} mt={1}>
          <LoadingButton
            text="Tambah"
            isLoading={isLoading}
            onClick={handleAdd}
          />
        </Box>
      </ModalFC>
    </Box>
  );
}
